import { Switch } from "react-router";
import { Route } from "react-router";
import Home from "../pages/screens/Home/Home";
import PreHome from "../pages/screens/Home/PreHome";
import CorpoClinico from '../pages/screens/CorpoClinico/CorpoClinico'
import MedicoTerceiro from '../pages/screens/MedicoTerceiro/MedicoTerceiro'
import Multiprofissional from '../pages/screens/Multiprofissional/Multiprofissional'
import AutorizacaoEspecial from '../pages/screens/AutorizacaoEspecial/AutorizacaoEspecial'
import MedicoAssistente from '../pages/screens/MedicoAssistente/MedicoAssistente'
import MedicoParceiro from '../pages/screens/MedicoParceiro/MedicoParceiro'
import SuccessForm from '../pages/screens/FinishForms/SuccessFormDataStep'
import ProtocolComponent from '../pages/screens/ProtocolStatus/ProtocolComponent'
import UserHome from '../pages/screens/UserHome/UserHome'
import Login from '../pages/screens/Login/Login'
import Recadastramento from '../pages/screens/Recadastramento/Recadastramento'
import PrivateRoute from "./PrivateRoute"

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={PreHome} />
      <Route exact path="/login" component={Login} />
      <Route exact path="/home" component={Home} />
      <Route exact path="/corpoclinico" component={CorpoClinico} />
      <Route exact path="/MedicoTerceiro" component={MedicoTerceiro} />
      <Route exact path="/medicoassistente" component={MedicoAssistente} />
      <Route exact path="/multiprofissional" component={Multiprofissional} />
      <Route exact path="/autorizacaoespecial" component={AutorizacaoEspecial} />
      <Route exact path="/medicoparceiro" component={MedicoParceiro} />
      <Route exact path="/protocolo" component={SuccessForm} />
      <Route exact path="/buscarprotocolo" component={ProtocolComponent} />
      <PrivateRoute path="/userhome">
        <UserHome />
      </PrivateRoute>
      <PrivateRoute path="/recadastramento">
        <Recadastramento />
      </PrivateRoute>
    </Switch>
  );
}
